<template>
  <v-container class="d-flex justify-center">No property.</v-container>
</template>

<script>
export default {
  name: "EndDesigner",
};
</script>
